import { SUCCESS, FAILED } from 'crom-api-constants'

export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityStack.components.StackContent.components.HistoryContent'

export const LOAD_HISTORY = 'LOAD_HISTORY'
export const HISTORY_LOADED = 'HISTORY_LOADED'
export const LOAD_HISTORY_REQUEST = 'LOAD_HISTORY_REQUEST'
export const LOAD_HISTORY_REQUEST_SUCCESS = `LOAD_HISTORY_REQUEST_${SUCCESS}`
export const LOAD_HISTORY_REQUEST_FAILED = `LOAD_HISTORY_REQUEST_${FAILED}`

export const VIRTUAL_LIST_ID = 'history_virtual_list'
